import { Suspense, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import KeywordFooter from "@/components/site/KeywordFooter";
import StickyContactBar from "@/components/site/StickyContactBar";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Cities from "@/pages/Cities";
import CityDetail from "@/pages/CityDetail";
import Regions from "@/pages/Regions";
import RegionDetail from "@/pages/RegionDetail";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import ServiceCity from "@/pages/ServiceCity";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Sitemap from "@/pages/Sitemap";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App bg-[#F4F4F0] text-[#060913] antialiased pb-[52px] sm:pb-[56px]">
      <HelmetProvider>
        <BrowserRouter>
        <SmoothScroll>
          <ScrollToTop />
          <Nav />
          <Suspense fallback={<div className="min-h-screen bg-[#F4F4F0]" />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/cities" element={<Cities />} />
              <Route path="/cities/:slug" element={<CityDetail />} />
              <Route path="/regions" element={<Regions />} />
              <Route path="/regions/:slug" element={<RegionDetail />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/sitemap" element={<Sitemap />} />
              {/* SEO landing page pattern: /service-slug-city-slug */}
              <Route path="/:combo" element={<ServiceCity />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
          <KeywordFooter />
          <Footer />
          <StickyContactBar />
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                borderRadius: 0,
                fontFamily: "IBM Plex Sans, sans-serif",
              },
            }}
          />
        </SmoothScroll>
      </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
